export const MODAL_ELEMENT_ID = '#__next';
